import {app} from "@tva/app";
import {downgradeComponent} from "@angular/upgrade/static";
import * as angular from "angular";
import {NotificationComponent} from "@tva/ng-migration/uicomponents/components";

app.directive(
  "appNotification",
  downgradeComponent({
    component: NotificationComponent,
  }) as angular.IDirectiveFactory
);


app.directive("uiGridMigration", () => ({
  restrict: "AEC",
  transclude: true,
  template: `
    <div ui-grid="gridOptions" ui-grid-pagination ui-grid-exporter ui-grid-resize-columns ui-grid-selection></div>
   `,
}));
